import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/mobile/share-linke-logo.svg'
import _imports_1 from '@/assets/images/mobile/text-share-link-1.png'
import _imports_2 from '@/assets/images/mobile/text-share-link-2.png'
import _imports_3 from '@/assets/images/mobile/share-image.svg'
import _imports_4 from '@/assets/images/mobile/gift-icon.svg'
import _imports_5 from '@/assets/images/mobile/second-page-icon-1.svg'
import _imports_6 from '@/assets/images/mobile/second-page-icon-2.svg'
import _imports_7 from '@/assets/images/mobile/second-page-icon-3.svg'
import _imports_8 from '@/assets/images/mobile/second-page-icon-4.svg'


const _hoisted_1 = { class: "container-mobile overflow-auto" }
const _hoisted_2 = { class: "content position-relative" }
const _hoisted_3 = { class: "share-link-image d-flex flex-column align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "title-logo",
  src: _imports_0,
  alt: "share-logo"
}
const _hoisted_5 = {
  key: 1,
  class: "title-text"
}
const _hoisted_6 = {
  key: 2,
  class: "img-en",
  src: _imports_1,
  alt: "share-logo"
}
const _hoisted_7 = {
  key: 0,
  class: "title-2 text-white fw-bold mt-1 text-center"
}
const _hoisted_8 = {
  key: 1,
  src: _imports_2,
  class: "title-2-en",
  alt: "share-text"
}
const _hoisted_9 = { class: "text-white mt-1 fs-6 text-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  class: "mt-2 share-img-3",
  src: _imports_3,
  alt: "share-image"
}, null, -1)
const _hoisted_11 = { class: "share-link-content mx-auto pb-3 position-relative z-0" }
const _hoisted_12 = { class: "first-page-container bg-white p-3 rounded-3 position-relative" }
const _hoisted_13 = { class: "dashed-container rounded-3 d-flex flex-column align-items-center px-1 position-relative" }
const _hoisted_14 = { class: "text-black mt-3 fs-6" }
const _hoisted_15 = { class: "code text-black mt-1 fw-semibold" }
const _hoisted_16 = { class: "gift-package d-flex align-items-start rounded-5 py-2 px-3 mt-1" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "gift-icon"
}, null, -1)
const _hoisted_18 = { class: "gift-text m-0 ms-2" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "blue-circle c1" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "blue-circle c2" }, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "blue-circle c3" }, null, -1)
const _hoisted_22 = { class: "second-page-container p-3 rounded-3 position-relative mt-3 d-flex align-items-center flex-column" }
const _hoisted_23 = { class: "title-page text-center text-white mt-2 position-relative" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "fails-note mt-1" }, "如打开失败，请连接VPN后重试", -1)
const _hoisted_25 = { class: "content-page d-flex flex-column bg-white mt-2 rounded-3 position-relative" }
const _hoisted_26 = { class: "item d-flex dashed-line position-relative" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    alt: "logo"
  })
], -1)
const _hoisted_28 = { class: "item-content" }
const _hoisted_29 = { class: "fs-6 text-black" }
const _hoisted_30 = ["href"]
const _hoisted_31 = { class: "item d-flex dashed-line position-relative" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: "telegram"
  })
], -1)
const _hoisted_33 = { class: "item-content" }
const _hoisted_34 = { class: "fs-6 text-black" }
const _hoisted_35 = {
  class: "second-page-link",
  href: "https://t.me/juechenvpn1"
}
const _hoisted_36 = { class: "item d-flex dashed-line position-relative" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "icon-1 me-2 d-flex justify-content-center align-items-center rounded-circle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    alt: "support"
  })
], -1)
const _hoisted_38 = { class: "item-content" }
const _hoisted_39 = { class: "fs-6 text-black" }
const _hoisted_40 = ["href"]
const _hoisted_41 = { class: "item d-flex" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "icon-1 me-2 d-flex justify-content-center align-items-center rounded-circle" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    alt: "mail"
  })
], -1)
const _hoisted_43 = { class: "item-content" }
const _hoisted_44 = { class: "fs-6 text-black" }
const _hoisted_45 = {
  class: "second-page-link",
  href: "https://juechenvpn@gmail.com"
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", { class: "white-c1" }, null, -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "white-c2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_share_url_part = _resolveComponent("share-url-part")!
  const _component_share_image_part = _resolveComponent("share-image-part")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["text-white pt-3 d-flex text-center justify-content-center", [_ctx.$route.query.lang?.toString().toLowerCase() == 'en'? 'title': '']])
        }, [
          (_ctx.$route.query.lang?.toString().toLowerCase() == 'en')
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.$route.query.lang?.toString().toLowerCase() == 'en')
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString($setup.local.share_link_1), 1))
            : _createCommentVNode("", true),
          (_ctx.$route.query.lang?.toString().toLowerCase() !== 'en')
            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.$route.query.lang?.toString().toLowerCase() == 'en')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString($setup.local.share_link_2), 1))
          : _createCommentVNode("", true),
        (_ctx.$route.query.lang?.toString().toLowerCase() !== 'en')
          ? (_openBlock(), _createElementBlock("img", _hoisted_8))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_9, _toDisplayString($setup.local.share_link_3), 1),
        _hoisted_10
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString($setup.local.share_link_4), 1),
            _createElementVNode("div", _hoisted_15, _toDisplayString($setup.data.code), 1),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("p", _hoisted_18, _toDisplayString($setup.local.share_link_5), 1)
            ]),
            ($setup.data.p == 'url')
              ? (_openBlock(), _createBlock(_component_share_url_part, { key: 0 }))
              : _createCommentVNode("", true),
            ($setup.data.p == 'image')
              ? (_openBlock(), _createBlock(_component_share_image_part, {
                  key: 1,
                  qrId: "qrcode1"
                }))
              : _createCommentVNode("", true),
            _hoisted_19,
            _hoisted_20,
            _hoisted_21
          ])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, _toDisplayString($setup.local.share_link_11), 1),
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString($setup.local.share_link_12), 1),
                _createElementVNode("a", {
                  class: "second-page-link",
                  href: $setup.websiteHost
                }, _toDisplayString($setup.local.share_link_14), 9, _hoisted_30)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, _toDisplayString($setup.local.share_link_15), 1),
                _createElementVNode("a", _hoisted_35, _toDisplayString($setup.local.share_link_17), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createTextVNode(_toDisplayString($setup.local.share_link_18), 1),
                  _createElementVNode("span", null, _toDisplayString($setup.local.share_link_19), 1)
                ]),
                _createElementVNode("a", {
                  class: "second-page-link",
                  href: $setup.supportLink
                }, _toDisplayString($setup.supportLink.replace(/^https?:\/\//, "")), 9, _hoisted_40)
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _hoisted_42,
              _createElementVNode("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createTextVNode(_toDisplayString($setup.local.share_link_21), 1),
                  _createElementVNode("span", null, _toDisplayString($setup.local.share_link_22), 1)
                ]),
                _createElementVNode("a", _hoisted_45, _toDisplayString($setup.local.share_link_23), 1)
              ])
            ])
          ]),
          _hoisted_46,
          _hoisted_47
        ])
      ])
    ])
  ]))
}